import { Module } from "vuex";
import { Component } from 'vue';
import { RootState } from '..';
import { MODAL_SHOW, MODAL_HIDE } from '../mutation-types';

export interface EventMap {
  [key: string]: Function;
}

export interface ModalState {
  component: Component | null;
  props: object;
  events: EventMap;
  visible: boolean;
  info: string;
}

const ModalModule: Module<ModalState, RootState> = {
  namespaced: true,
  state: {
    component: null,
    props: {},
    events: {},
    visible: false,
    info: ''
  },
  mutations: {
    [MODAL_SHOW]: (state, payload: {component: Component; props: object; events: EventMap; info: string}) => {
      state.component = payload.component
      state.props = payload.props
      state.events = payload.events
      state.info = payload.info
      state.visible = true
    },
    [MODAL_HIDE]: (state) => {
      state.visible = false
    }
  },
}

export default ModalModule
